import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Axios from 'axios';
import './index.scss';


// Utils
import LimitMask from '../../utils/LimitMask';

// Container
import { apiHost, sourceHost } from '../../utils/Shared/constant';
import ModalBox from '../../utils/ModalBox';
import { loginRedirect } from '../../utils/Shared/methods';
// import { withRouter } from 'react-router-dom';

class ShelterNewRecord extends Component {
	constructor(params) {
		super(params);
		this.state = {
			countiesTownsVillagesData: null,
			currentShelterIndex: null,
		};

		this.state = {
			id: 0,
			isAuthMemberLogin: false,
			isMemberLogin: false,
			shelter_name: '',
			shelter_id: '',
			management_level: '-',
			shelter_address: '',
			serve_village: '',
			shelter_inside_count: '',
			shelter_outside_count: '',
			shelter_count: '',
			shelter_area: '',
			for_diaster: '',
			shelter_feature: '',
			shelter_feature2: 1,
			contact_name: '',
			contact_tel: '',
			manage_department: '',
			manage_name: '',
			manage_tel: '',
			manage_mobile: '',
			longitude: '',
			latitude: '',
			shelter_manage: '',
			status: '',
			isModalOpen: false,
			selectedDisasters: [],//適用災別
			selectedFeatures: [],//空間特性
			weakShelterValue: '',//適合避難弱者安置
			applicant_name: '',//申請人姓名
			applicant_department: '',//申請人單位
			applicant_title: '',//申請人職稱
			applicant_tel: '',//申請人電話
			applicant_email: '',//申請人信箱
			shelter_area_outside: '',//室外容納面積(平方公尺)
			facility_status: '',//設施設備情形
			adaptForWeaker: 1,//適合避難弱者安置
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onLoadHeaderColor('PINK');
		this.props.onLoadHeaderTheme('DARK');
		this.props.onLoadShowLanguage('HIDE');
		const breadcrumb = [
			{ name: '首頁', href: '/' },
			{ name: '撤離與收容評估', href: '/evaluation/evacuation' },
			{ name: '收容所資訊查詢', href: '/evaluation/evacuation/shelter' },
			{ name: '單筆新增', href: '/evaluation/evacuation/shelter/-1' },
		]
		this.props.onLoadShowBreadcrumb('SHOW', breadcrumb);
		let id = this.props.match.params.id;
		//-1:單筆新增; -2:批次新增
		console.log(id);
		this.setState({ id: id });

		this.getAvailableCounty();
		this.getUpdateDate();
		this.checkMemberLogin();
		this.getDiaster();
		this.getShelterFeature();
		// this.checkAuthMemberLogin();

		 // 使用 pageshow 事件，當頁面從快取顯示時觸發
		 window.addEventListener('pageshow', this.handlePageShow);
	}

	componentWillUnmount() {
		// 移除 pageshow 事件監聽
		window.removeEventListener('pageshow', this.handlePageShow);
	}
	handlePageShow = (event) => {
		// 檢查頁面是否從快取載入（從瀏覽器的返回按鈕）
		if (event.persisted) {	
			// 強制刷新頁面
			window.location.reload();
		}
	}







	checkAuthMemberLogin = () => {
		Axios.post(`${apiHost}/api/Account/IsAuthMember`, {}
			, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + window.localStorage.getItem('user-token'),
				}
			}
		).then(result => {
			this.setState({ isAuthMemberLogin: result.data.Result });
			if (result.data.Result === false) {
				alert('沒有權限');
				this.props.history.push('/login');
			}
		}).catch((error) => {
			alert('沒有權限');
			this.props.history.push('/login');
		})
	}

	checkMemberLogin = () => {
		if (window.localStorage.getItem('user-token')) {
			this.setState({ isMemberLogin: true });
		} else {
			this.setState({ isModalOpen: true });
		}
	}
	getAvailableCounty = () => {
		Axios.get(`${apiHost}/api/Setting/GetCountiesTownsVillagesData`)
			.then(result => {
				this.setState({ countiesTownsVillagesData: result.data });
			})
	}

	handleCountyDistrictPickSelected = selectedCode => {
		const { countiesTownsVillagesData } = this.state;
		const selectedDistrict = countiesTownsVillagesData.counties.find(({ code }) => code === selectedCode);
		this.setState({ selectedCounty: selectedDistrict, selectedTown: null, selectedVillage: null });
	}

	handleTownDistrictPickSelected = selectedCode => {
		const { selectedCounty } = this.state;
		if (selectedCounty === null) return;
		const selectedDistrict = selectedCounty ? selectedCounty.towns.find(({ code }) => code === selectedCode) : null;
		this.setState({ selectedTown: selectedDistrict, selectedVillage: null, isVillageShow: false });
	}

	handleVillageDistrictPickSelected = selectedCode => {
		const { selectedTown, selectedCounty } = this.state;
		if (selectedCounty === null) return;
		if (selectedTown === null) return;
		const selectedDistrict = selectedTown.villages.find(({ code }) => code === selectedCode);
		this.setState({ selectedVillage: selectedDistrict, });
	}

	getUpdateDate = () => {
		Axios.get(`${apiHost}/api/Setting/GetShelterUpdateDatetime`)
			.then(res => {
				this.setState({ updateDate: res.data.update });
			})
	}

	getDiaster = () => {
		Axios.get(`${apiHost}/api/ShelterInfo/GetAdvancedTerm`, { params: { category: '災別' } })
			.then(result => {
				this.setState({ diasterList: result.data });
			})
	}

	getShelterFeature = () => {
		Axios.get(`${apiHost}/api/ShelterInfo/GetAdvancedTerm`, { params: { category: '空間特性' } })
			.then(result => {
				this.setState({ shelterFeatureList: result.data });
			})
	}

	handleDiasterPickSelected = (e) => {
		const selectedDisasters = [];
		const selectedCheckboxes = document.querySelectorAll('input[name="diaster"]:checked');

		selectedCheckboxes.forEach(checkbox => {
			selectedDisasters.push(checkbox.id);
		});

		this.setState({ selectedDisasters: selectedDisasters });
	}

	handleFeaturePickSelected = (e) => {
		const selectedFeatures = [];
		const selectedCheckboxes = document.querySelectorAll('input[name="feature"]:checked');

		selectedCheckboxes.forEach(checkbox => {
			selectedFeatures.push(checkbox.id);
		});
		this.setState({ selectedFeatures: selectedFeatures });
	}
	handleSubmit = () => {
		//Submit form data
		const formData = {
			shelter_name: this.state.shelter_name,
			shelter_id: this.state.shelter_id,
			management_level: this.state.management_level,
			shelter_address: this.state.shelter_address,
			serve_village: this.state.serve_village,
			shelter_inside_count: this.state.shelter_inside_count,
			shelter_outside_count: this.state.shelter_outside_count,
			shelter_count: this.state.shelter_count,
			shelter_area: this.state.shelter_area,
			for_disaster: this.state.selectedDisasters.join('/'),
			shelter_feature: this.state.selectedFeatures.join('/'),
			shelter_feature2: this.state.shelter_feature2 === '1' ? true : false,
			contact_name: this.state.contact_name,
			contact_tel: this.state.contact_tel,
			contact_mobile: this.state.contact_mobile,
			manage_department: this.state.manage_department,
			mange_name: this.state.manage_name,
			mange_tel: this.state.manage_tel,
			mange_mobile: this.state.manage_mobile,
			county_id: this.state.selectedCounty ? this.state.selectedCounty.code : null,
			district_id: this.state.selectedTown ? this.state.selectedTown.code : null,
			village_id: this.state.selectedVillage ? this.state.selectedVillage.code : null,
			longitude: this.state.longitude,
			latitude: this.state.latitude,
			applicant_name: this.state.applicant_name,
			applicant_department: this.state.applicant_department,
			applicant_title: this.state.applicant_title,
			applicant_tel: this.state.applicant_tel,
			applicant_email: this.state.applicant_email,
			shelter_area_outside: this.state.shelter_area_outside,
			facility_status: this.state.facility_status,
			adaptForWeaker: this.state.adaptForWeaker === '1' ? true : false
		};


		let chkResult = this.chkBeforeSubmit(formData);
		console.log(chkResult);
		if (chkResult === '') {
			Axios.post(`${apiHost}/api/ShelterInfo/AddShelterReview`,
				formData,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + window.localStorage.getItem('user-token'),
					}
				}).then(
					res => {
						if (res.data.Outstring === "0000") {
							alert('已收到您新增、編輯的紀錄，待管理人員審核後，系統將寄送審核結果給您，請耐心等候。');
							window.location.href = "/evaluation/evacuation/shelter";
						} else {
							alert(res.data.Result);
						}
					});
		} else {
			alert(chkResult);
		}
		console.log(formData);
	}

	chkRequireMent = (data) => {
		let result = [];
		if (!data.shelter_name) { result.push('收容所名稱'); }
		if (!data.shelter_id) { result.push('收容所代碼'); }
		if (!data.management_level) { result.push('管理層級'); }
		if (!data.shelter_address) { result.push('收容所地址'); }
		if (!data.serve_village) { result.push('服務村里'); }
		if (!data.shelter_inside_count && data.shelter_inside_count != 0) { result.push('室內可收容人數'); }
		if (!data.shelter_outside_count && data.shelter_outside_count != 0) { result.push('室外可收容人數'); }
		if (!data.shelter_area && data.shelter_area != 0) { result.push('室內容納面積(平方公尺)'); }
		if (!data.for_disaster) { result.push('適用災別'); }
		if (!data.shelter_feature) { result.push('空間特性'); }
		return result;
	}

	chkIsNumebr = (data) => {
		let result = [];
		if (isNaN(Number(data.shelter_inside_count))) { result.push('室內可收容人數'); }
		if (isNaN(Number(data.shelter_outside_count))) { result.push('室外可收容人數'); }
		if (isNaN(Number(data.longitude))) { result.push('TWD97 X軸'); }
		if (isNaN(Number(data.latitude))) { result.push('TWD97 Y軸'); }
		return result;
	}

	chkCoordinateRange = (data) => {
		let result = [];
		const longitude = Number(data.longitude);
		const latitude = Number(data.latitude);
		if (!isNaN(longitude) && (longitude < 118 || longitude > 122)) {
			result.push('TWD97 X軸必須在 118-122 之間。');
		}
		if (!isNaN(latitude) && (latitude < 21 || latitude > 27)) {
			result.push('TWD97 Y軸必須在 21-27 之間。');
		}
		return result;
	}

	chkBeforeSubmit = (data) => {
		let result = '';
		let r = this.chkRequireMent(data);
		if (r.length > 0) {
			result += r.join('、');
			result += '為必填欄位。\r\n';
		}

		let d = this.chkIsNumebr(data);
		if (d.length > 0) {
			result += d.join('、');
			result += '必須為數值。\r\n';
		}

		let c = this.chkCoordinateRange(data);
		if (c.length > 0) {
			result += c.join('\r\n') + '\r\n';
		}
		return result;
	}

	handleCancel = () => {
		window.history.back();
	}

	handleFileChange = (event) => {
		console.log(event.target.files[0]);
		this.setState({ selectedFile: event.target.files[0] });
	};

	handleUpload = () => {
		console.log(this.state.selectedFile);
		const formData = new FormData();
		formData.append("file", this.state.selectedFile);

		formData.append("applicant_name", this.state.applicant_name);
		formData.append("applicant_department", this.state.applicant_department);
		formData.append("applicant_title", this.state.applicant_title);
		formData.append("applicant_tel", this.state.applicant_tel);
		formData.append("applicant_email", this.state.applicant_email);

		Axios.post(`${apiHost}/api/ShelterInfo/UploadShelterReviewList`,
			formData,
			{
				headers: {
					'Authorization': 'Bearer ' + window.localStorage.getItem('user-token'),
					'Content-Type': 'multipart/form-data'
				}
			}).then(
				res => {
					if (res.data.Outstring === "0000") {
						alert('已收到您新增、編輯的紀錄，待管理人員審核後，系統將寄送審核結果給您，請耐心等候。');
						window.location.href = "/evaluation/evacuation/shelter";
					} else {
						alert(res.data.Result);
					}
				});
	};

	handleCancelUpload = () => {
		window.history.back();
	}

	handleDownloadTemplate = () => {
		window.location.href = `${sourceHost}/Shelter/RawExcel?type=3`;
	}

	render() {
		const { diasterList, shelterFeatureList } = this.state;
		const { countiesTownsVillagesData, selectedCounty, selectedTown, selectedVillage } = this.state;
		return (
			<React.Fragment>
				<Helmet>
					<title>減災動資料 - 撤離與收容評估</title>
				</Helmet>
				<LimitMask prevPage="/evaluation/evacuation" />
				<ModalBox
					open={this.state.isModalOpen}
					theme="-pink"
					onRequestClose={() => loginRedirect()}
				>
					<div className="modalbody -center">
						<p className="type-text -ch -md">請先登入再進行操作</p>
					</div>
					<div className="modalfooter -center">
						<button className="fill-button -pink" onClick={() => loginRedirect()}>登入</button>
					</div>
				</ModalBox>
				<div className="evacuation-page">
					{
						this.state.id === "-1" &&
						<div className="container">
							<div className="evacuation-chart-title">
								<div className="title">單筆新增</div>
							</div>
							<div>
								<table className='shelter-data-add-single-table'>
									<tbody>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>災民收容所名稱</th>
											<td><input type='text'
												value={this.state.shelter_name}
												onChange={(e) => { this.setState({ shelter_name: e.target.value }) }}></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>災民收容所編號</th>
											<td><input type='text'
												value={this.state.shelter_id}
												onChange={(e) => { this.setState({ shelter_id: e.target.value }) }}></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>管理層級</th>
											<td>
												<select
													value={this.state.management_level}
													onChange={(e) => { this.setState({ management_level: e.target.value }) }}
												>
													<option key='1' value='-'>-</option>
													<option key='2' value='縣市'>縣市</option>
													<option key='3' value='公所'>公所</option>
												</select>
											</td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>收容所地址</th>
											<td>
												<select status="normal" name="county"
													value={selectedCounty ? selectedCounty.code : '-1'}
													onChange={(e) => { this.handleCountyDistrictPickSelected(e.target.value) }}>
													<option key='-1' value='-1'>縣市名稱</option>
													{
														countiesTownsVillagesData &&
														countiesTownsVillagesData.counties.map((item, index) =>
															<option key={index} value={item.code}>{item.county}</option>
														)
													}
												</select>
												<select status="normal" name="town"
													value={selectedTown ? selectedTown.code : ''}
													onChange={(e) => this.handleTownDistrictPickSelected(e.target.value)}>
													<option key="-1" value='-1'>鄉鎮市區</option>
													{
														selectedCounty &&
														selectedCounty.towns.map((item, index) =>
															<option key={index} value={item.code}>{item.town}</option>
														)
													}
												</select>
												<select status="normal" name="village"
													value={selectedVillage ? selectedVillage.code : ''}
													onChange={(e) => this.handleVillageDistrictPickSelected(e.target.value)}>
													<option key="-1" value='-1'>村里別</option>
													{
														selectedTown &&
														selectedTown.villages.map((item, index) =>
															<option key={index} value={item.code}>{item.village}</option>
														)
													}
												</select>

												<input type='text'
													value={this.state.shelter_address}
													onChange={(e) => { this.setState({ shelter_address: e.target.value }) }}
												></input>
											</td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>服務里別</th>
											<td><input type='text'
												value={this.state.serve_village}
												onChange={(e) => { this.setState({ serve_village: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>室內可收容人數</th>
											<td><input type='number'
												value={this.state.shelter_inside_count}
												onChange={(e) => {
													this.setState({ shelter_inside_count: Number(e.target.value) })
													this.setState({ shelter_count: Number(e.target.value) + Number(this.state.shelter_outside_count) })
												}
												}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>室外可收容人數</th>
											<td><input type='number'
												value={this.state.shelter_outside_count}
												onChange={(e) => {
													this.setState({ shelter_outside_count: Number(e.target.value) })
													this.setState({ shelter_count: Number(this.state.shelter_inside_count) + Number(e.target.value) })
												}}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>可收容人數總計</th>
											<td><input type='number'
												value={this.state.shelter_count}
												disabled
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>室內容納面積(平方公尺)</th>
											<td><input type='number'
												value={this.state.shelter_area}
												onChange={(e) => { this.setState({ shelter_area: Number(e.target.value) }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>室外容納面積(平方公尺)</th>
											<td><input type='number'
												value={this.state.shelter_area_outside}
												onChange={(e) => { this.setState({ shelter_area_outside: Number(e.target.value) }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>適用災別</th>
											<td style={{ display: 'flex', borderBottom: '0px' }} >
												{diasterList && diasterList.map(item => (
													<div key={item.Name} className='shelter-data-add-table-check'>
														<input type="checkbox" id={item.Name} name="diaster" onChange={this.handleDiasterPickSelected} checked={this.state.selectedDisasters.includes(item.Name)} />
														<label htmlFor={item.Name}>
															{item.Name}
														</label>
													</div>
												))}
											</td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>空間特性</th>
											<td style={{ display: 'flex', borderBottom: '0px' }}>
												{shelterFeatureList && shelterFeatureList.map(item => (
													<div key={item.Name} className='shelter-data-add-table-check'>
														<input type="checkbox" id={item.Name} name="feature" onChange={this.handleFeaturePickSelected} checked={this.state.selectedFeatures.includes(item.Name)} />
														<label htmlFor={item.Name}>
															{item.Name}
														</label>
													</div>
												))}
											</td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>適合避難弱者安置</th>
											<td style={{ display: 'flex', borderBottom: '0px' }}>
												<div className='shelter-data-add-table-check'>
													<input type="radio" id="yes" name="weakShelter" value="1"
														onChange={(e) => { this.setState({ adaptForWeaker: e.target.value }) }}
														checked={this.state.adaptForWeaker === '1'} />
													<label htmlFor="yes">是</label>
												</div>
												<div className='shelter-data-add-table-check'>
													<input type='radio' id="no" name="weakShelter" value="0"
														onChange={(e) => { this.setState({ adaptForWeaker: e.target.value }) }}
														checked={this.state.adaptForWeaker === '0'} />
													<label htmlFor="no">否</label>
												</div>
											</td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>聯絡人姓名</th>
											<td><input type='text'
												value={this.state.contact_name}
												onChange={(e) => { this.setState({ contact_name: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>聯絡人電話</th>
											<td><input type='tel'
												value={this.state.contact_tel}
												onChange={(e) => { this.setState({ contact_tel: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>聯絡人手機號碼</th>
											<td><input type='tel'
												value={this.state.contact_mobile}
												onChange={(e) => { this.setState({ contact_mobile: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>收容所管理單位</th>
											<td><input type='text'
												value={this.state.manage_department}
												onChange={(e) => { this.setState({ manage_department: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>管理人姓名</th>
											<td><input type='text'
												value={this.state.manage_name}
												onChange={(e) => { this.setState({ manage_name: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>管理人電話</th>
											<td><input type='tel'
												value={this.state.manage_tel}
												onChange={(e) => { this.setState({ manage_tel: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>管理人手機號碼</th>
											<td><input type='tel'
												value={this.state.manage_mobile}
												onChange={(e) => { this.setState({ manage_mobile: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>TWD97 X軸</th>
											<td><input type='number'
												value={this.state.longitude}
												onChange={(e) => { this.setState({ longitude: Number(e.target.value) }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>TWD97 Y軸</th>
											<td><input type='number'
												value={this.state.latitude}
												onChange={(e) => { this.setState({ latitude: Number(e.target.value) }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>申請人姓名</th>
											<td><input type='text'
												value={this.state.applicant_name}
												onChange={(e) => { this.setState({ applicant_name: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>申請人單位</th>
											<td><input type='text'
												value={this.state.applicant_department}
												onChange={(e) => { this.setState({ applicant_department: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>申請人職稱</th>
											<td><input type='text'
												value={this.state.applicant_title}
												onChange={(e) => { this.setState({ applicant_title: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>申請人電話</th>
											<td><input type='tel'
												value={this.state.applicant_tel}
												onChange={(e) => { this.setState({ applicant_tel: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>申請人信箱</th>
											<td><input type='email'
												value={this.state.applicant_email}
												onChange={(e) => { this.setState({ applicant_email: e.target.value }) }}
											></input></td>
										</tr>
										<tr>
											<th><span style={{ color: 'red' }}>*</span>設施設備情形</th>
											<td><input type='text'
												value={this.state.facility_status}
												onChange={(e) => { this.setState({ facility_status: e.target.value }) }}
											></input></td>
										</tr>
									</tbody>
								</table>
								<span>*個資使用聲明：</span>
								<br></br>
								您所提供之個人資料僅供本中心與您聯繫確認您所提供的審核資料之用，不做其他用途，本站亦遵守中華民國「個人資料保護法」相關要求，您所提供的資料，本中心將嚴格的管理及保護。

								<div className='shelter-data-add-btnbox'>
									<input type='button' className='btn-save' value='送審核' onClick={this.handleSubmit}></input>
									<input type='button' className='btn-canel' value='取消' onClick={this.handleCancel}></input>
								</div>


							</div>
						</div>
					}

					{
						this.state.id === "-2" &&
						<div className='container'>
							<div className="evacuation-chart-title">
								<div className="title">批次新增申請</div>
							</div>
							<table className='shelter-data-add-single-table' cellSpacing={0} cellPadding={0}>
								<tbody>
									<tr>
										<th>格式範例</th>
										<td>
											<input type='button' className='shelter-databtn-btn' value='範例下載' onClick={this.handleDownloadTemplate}></input>
											<span>※請注意上傳檔案欄位須符合規定，否則將上傳失敗。</span>
										</td>
									</tr>
									<tr>
										<th><span style={{ color: 'red' }}>*</span>匯入檔案上傳</th>
										<td>
											<input type="file" onChange={this.handleFileChange} />
										</td>
									</tr>
									<tr>
										<th><span style={{ color: 'red' }}>*</span>申請人姓名</th>
										<td><input type='text'
											value={this.state.applicant_name}
											onChange={(e) => { this.setState({ applicant_name: e.target.value }) }}
										></input></td>
									</tr>
									<tr>
										<th><span style={{ color: 'red' }}>*</span>申請人單位</th>
										<td><input type='text'
											value={this.state.applicant_department}
											onChange={(e) => { this.setState({ applicant_department: e.target.value }) }}
										></input></td>
									</tr>
									<tr>
										<th><span style={{ color: 'red' }}>*</span>申請人職稱</th>
										<td><input type='text'
											value={this.state.applicant_title}
											onChange={(e) => { this.setState({ applicant_title: e.target.value }) }}
										></input></td>
									</tr>
									<tr>
										<th><span style={{ color: 'red' }}>*</span>申請人電話</th>
										<td><input type='tel'
											value={this.state.applicant_tel}
											onChange={(e) => { this.setState({ applicant_tel: e.target.value }) }}
										></input></td>
									</tr>
									<tr>
										<th><span style={{ color: 'red' }}>*</span>申請人信箱</th>
										<td><input type='email'
											value={this.state.applicant_email}
											onChange={(e) => { this.setState({ applicant_email: e.target.value }) }}
										></input></td>
									</tr>
								</tbody>
							</table>
							<span>*個資使用聲明：</span>
							<br></br>
							您所提供之個人資料僅供本中心與您聯繫確認您所提供的審核資料之用，不做其他用途，本站亦遵守中華民國「個人資料保護法」相關要求，您所提供的資料，本中心將嚴格的管理及保護。
							<div className='shelter-data-add-btnbox'>
								<input type="button" className='btn-save' onClick={this.handleUpload} value='送審核'></input>
								<input type="button" className='btn-canel' onClick={this.handleCancelUpload} value='取消'></input>
							</div>
						</div>
					}
				</div>
			</React.Fragment>
		);
	}
}
// export default withRouter(ShelterNewRecord);
export default ShelterNewRecord;

